// @flow

import ko from 'rgs-knockout';

import 'ko-component-btn-radio-group';
import 'ko-component-fio-input';
import 'ko-component-person-identity-document-editor';
import 'ko-component-file-upload-input';
import 'ko-component-react-component-placement';

import Model from './js/model';
import template from './templates/template.html';

export const lkTypes = {
	juridical: 2,
	physical: 1
};

ko.components.register('myrgs-auth2-form', {
	viewModel: Model,
	template: template(),
});
